import React from 'react';
import Table from '../../component/table/table'
import {BASE_END_POINT} from '../../urls'
import axios from 'axios'
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import Pagination from '@material-ui/lab/Pagination';
import { MDBContainer,  MDBRow, MDBCol} from "mdbreact";
import './posts.css'
import {message,TreeSelect} from 'antd';
import allStrings from '../../assets/strings'
import { connect } from 'react-redux';
import {NavLink, withRouter,Redirect} from 'react-router-dom'
import {ChangeLanguage} from '../../redux/actions/LanguageAction'
import moment from 'moment'
//import { CSVLink } from "react-csv";
import {SearchOutlined} from '@ant-design/icons';

const { TreeNode } = TreeSelect;
//const { SHOW_PARENT } = TreeSelect;
// eslint-disable-next-line no-unused-vars
let headers = [
  { label: "#", key: "id" },
  { label: "Owner", key: "owner" },
  { label: "Type", key: "type" },
  { label: "Status", key: "status" },
  { label: "Privacy", key: "privacy" },
  { label: "LikesCount", key: "likesCount" },
  { label: "CommentsCount", key: "commentsCount" },
  { label: "CreatedAt", key: "createdAt" },
  
];
 
let csvData = [
  
];

class posts extends React.Component {
  
  state={
    posts:[],
    posts2:[],
    loading:true,
    refresh:false,
    page:1,
    pages:1,
    filterType:{},
    value:'',
    count:0,
    type:null,
    search:null,
    owner:this.props.location.state?this.props.location.state.owner:null
  }

  constructor(props){
    super(props)
    window.scrollTo(0,0)
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
    }else{
      allStrings.setLanguage('en')
    }
  }

  componentDidMount(){
    this.getPosts(1,false)
    this.getPostsWithoutPagenation()
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
    }else{
      allStrings.setLanguage('en')
    }
  }

  /**
  * get data with pagenation request 
  */
  getPosts = (page,refresh,rest) =>{
    this.setState({loading:true})
    let {type,search,owner} = this.state
    let url = `${BASE_END_POINT}posts?page=${page}`
    if(type !== null){
      let str = '&type='+ type
      url += str
    }
   
    if(search !== null){
      let str = '&search='+ search
      url += str
    }
    if(owner !== null){
      let str = '&owner='+ owner
      url += str
    }
    if(rest) url = `${BASE_END_POINT}posts`
    console.log(url)
    axios.get(url,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      }
    })
    .then(response=>{
      console.log("posts   ",response.data)
      var data = response.data.data.map(item=>[
        item.id,
        item.owner?item.owner.fullname?item.owner.fullname:"":"",
        item.type==="TEXT"?{type:'tag',value:allStrings.text}:
          item.type==="IMAGE"?{type:'tag',value:allStrings.image}:
          item.type==="VIDEO"?{type:'tag',value:allStrings.video}:
          item.type==="RECORD"?{type:'tag',value:allStrings.record}:
          item.type==="FILE"?{type:'tag',value:allStrings.file}:
          item.type==="GIFT"?{type:'tag',value:allStrings.gift}:
          item.type==="OCCASION"?{type:'tag',value:allStrings.occasion}:
          item.type==="MUSIC"?{type:'tag',value:allStrings.music}:
          item.type==="MOVIE"?{type:'tag',value:allStrings.movie}:
          {type:'tag',value:allStrings.location},

        item.status==="ACTIVE"?{type:'tag',value:allStrings.active}:{type:'tag',value:allStrings.notActive},
        
        item.privacy==="PUBLIC"?{type:'tag',value:allStrings.public}:
          item.privacy==="PRIVATE"?{type:'tag',value:allStrings.private}:
          item.privacy==="CUSTOM-GROUP"?{type:'tag',value:allStrings.customGroup}:
          {type:'tag',value:allStrings.publicRegion},
        item.likesCount,
        item.commentsCount,
        moment(item.createdAt).format('MMMM Do YYYY, h:mm a'),
        "action"])
      console.log("DATA   ",data)
      this.setState({
        loading:false,
        refresh:false,
        posts:response.data.data,
        posts2:data,
        page:response.data.page,
        pages:response.data.pageCount,
      })
    })
    .catch(error=>{
      console.log("error   ",error.response)
      console.log("error2   ",error)
      this.setState({loading:false,})
    })
  }
  /**
  * get data without pagenation request 
  */
  getPostsWithoutPagenation = (rest) =>{
    let url = `${BASE_END_POINT}posts/withoutPagenation/get`
    let {type,search,owner} = this.state
    if(type !== null){
      let str = '&type='+ type
      url += str
    }
    if(search !== null){
      let str = '&search='+ search
      url += str
    }
    if(owner !== null){
      let str = '&owner='+ owner
      url += str
    }
    if(rest) url = `${BASE_END_POINT}posts/withoutPagenation/get`
    axios.get(url,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      }
    })
    .then(response=>{
      console.log("USERS   ",response.data)
        csvData= response.data.map(item => {
          return {
            ...{id:item.id},
            ...{owner:item.owner?item.owner.fullname?item.owner.fullname:"":""},
            ...{type:item.type==="TEXT"?allStrings.text:
                item.type==="IMAGE"?allStrings.image:
                item.type==="VIDEO"?allStrings.video:
                item.type==="RECORD"?allStrings.record:
                item.type==="FILE"?allStrings.file:
                item.type==="GIFT"?allStrings.gift:
                item.type==="OCCASION"?allStrings.occasion:
                item.type==="MUSIC"?allStrings.music:
                item.type==="MOVIE"?allStrings.movie:
                allStrings.location},
            ...{status:item.status==="ACTIVE"?allStrings.active:allStrings.notActive},
            ...{privacy:item.privacy==="PUBLIC"?allStrings.public:
                item.privacy==="PRIVATE"?allStrings.private:
                item.privacy==="CUSTOM-GROUP"?allStrings.customGroup:
                allStrings.publicRegion},
              
            ...{likesCount:item.likesCount},
            ...{commentsCount:item.commentsCount},
            ...{createdAt:moment(item.createdAt).format('lll')},
          };
        });
        console.log(csvData)
      
    })
    .catch(error=>{
      console.log("error   ",error.response)
      console.log("error2   ",error)
    })
  }
  /**
  * delete request 
  */

  delete = (id) => {
    console.log("ID   ",id)
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}posts/${id}`,{
     headers: {
       'Content-Type': 'application/json',
       'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
     },
    })
    .then(response=>{
      l.then(() => message.success(allStrings.done, 2.5) )
      this.getPosts(this.state.page)
    })
    .catch(error=>{
        console.log(error.response)
        l.then(() => message.error(error.response.data.errors.msg[0].msg, 2.5))
    })
  }
  /**
  * add new row component
  */
  addNewRecordButton = () =>(
    <div style={{width:'100%'}}>
      <NavLink to="addposts">
        <Fab
          style={{background:'#117183',float:'left',margin:'50px 30px'}}
          variant="extended"
          size="medium"
          color="primary"
          aria-label="add"
        >
          <AddIcon />{allStrings.addNewRecored}
        </Fab>
      </NavLink>
       
    </div>
  )

  /**
  * pagination Buttons component
  */
  paginationButtons = () =>(
    <CardActions style={{display: 'inline-flex'}}>
        <Button 
        onClick={()=>{
          if(this.state.page!==1){
            this.getPosts(1)
            this.setState({page:1})
          }
        }}
        className="pagenation" >{allStrings.first}</Button>

        <Button 
        onClick={()=>{
         if(this.state.page>1){
            this.getPosts(this.state.page-1)
            this.setState({page:this.state.page-1})
         }
        }}
        className="pagenation">{allStrings.prev}</Button>
        
        <Pagination
        onChange={(event,page)=>{
        console.log("page   ",page)
        if(page!==this.state.page){
          this.getPosts(page)
          this.setState({page:page})
        }
        
        }} 
        defaultPage={1} page={this.state.page} count={this.state.pages} style={{color:`#117183 !important`}} />
        
        <Button 
        onClick={()=>{
          if(this.state.page<this.state.pages){
            this.getPosts(this.state.page+1)
            this.setState({page:this.state.page+1})
          }
        }}
        className="pagenation">{allStrings.next}</Button>

        <Button 
         onClick={()=>{
          if(this.state.page!==this.state.pages){
            this.getPosts(this.state.pages)
            this.setState({page:this.state.pages})
          }
        }}
        className="pagenation">{allStrings.last}</Button>

    </CardActions>
  )

  render(){
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('POSTS')) return <Redirect to='/Home' />

  return (
    <div className="App">
        
      <MDBContainer> 
      <MDBRow>
        <MDBCol md="12">
          <div className="screenTable">
          <Table
          /**table settings contain reload and csv  */
            settings = {
              <div>
                <i class="fab fa-searchengin searchIcon" onClick={()=>this.setState({showFilter:!this.state.showFilter})}></i>
                <span 
                style={{position: 'relative',padding: '4px',color: '#659FF1',fontSize: '25px',borderRadius:'50%',top:'4px',cursor: 'pointer'}}
                onClick={() => {this.setState({end:null,type:null,search:null});this.getPosts(1,false,true);this.getPostsWithoutPagenation(true)}}
                class="material-icons">
                  replay
                </span>
                {/* <CSVLink 
                  data={csvData} 
                  headers={headers} 
                  filename={"posts.csv"}
                  style={{padding: '10px',position: 'relative',top: '-5px'}}
                  >
                  <img alt="" src={require('../../assets/images/export-csv.png')} width="28"></img>
                </CSVLink> */}
              </div>
              
            }
            /**table filter  */
            filter ={
              <div>
                <div className={this.state.showFilter?'showClass':'hideClass'} style={{height:this.state.showFilter?"160px":"0px"}}>
                  <MDBRow>
                    
                      
                    <MDBCol xl="4" lg="4" md="4" sm="12">
                      <Button style={{background: '#117183',color: '#fff',width: '100%',margin: '32px auto'}} 
                        onClick={()=>{this.getPosts(1);this.getPostsWithoutPagenation()}}><SearchOutlined /> {allStrings.Search}</Button>
                      
                    </MDBCol>
                    <MDBCol xl="4" lg="4" md="4" sm="12">
                      <div class="md-form">
                      <label htmlFor="form605" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.Search}</label>
                      <input style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center',fontWeight:'300'}} type="text" id="form605"  class="form-control"
                        placeholder={allStrings.postsearch}
                        onChange={(e)=>{
                          this.setState({search:e.target.value})
                        }}  
                      />
                      </div>
                    </MDBCol>
                    <MDBCol xl="4" lg="4" md="4" sm="12">
                        <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.status}</label>
                        <TreeSelect virtual={false}
                          showSearch={false}
                          value={this.state.status}
                          style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',minHeight:'35px',marginBottom:'1rem'}} 
                          treeCheckable = {false}         
                          treeNodeFilterProp="title"                      
                          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                          placeholder={allStrings.status}
                          onChange={(value) => {
                          console.log(value)
                          this.setState({status:value});
                          }} 
                      
                      >
                          <TreeNode value="ACTIVE" title={allStrings.active} key="ACTIVE" />
                          <TreeNode value="NOT-ACTIVE" title={allStrings.notActive} key="NOT-ACTIVE" />
                      </TreeSelect>
                    </MDBCol>
                  </MDBRow>
                  
                </div>
              </div>
            }
            title={allStrings.posts}
            icon='star_outline'
            data={this.state.posts}
            data2={this.state.posts2}
            tableColumns={["#",allStrings.owner,allStrings.type,allStrings.status,allStrings.privacy,allStrings.likesCount,allStrings.commentsCount,allStrings.createdAt,allStrings.action]}
            loading={this.state.loading}
            deleteUser={(id)=>{this.delete(id)}}
            path='/postInfo'
            enableEdit={false}
            actionIndex={5}
            />
            {this.paginationButtons()}
            {/*this.addNewRecordButton()*/}
            </div>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
    </div> 
  )
  }
}

const mapToStateProps = state => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
})

const mapDispatchToProps = {
  ChangeLanguage
}

export default  withRouter(
  connect(mapToStateProps,mapDispatchToProps)(posts)
);

